import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Modal from "@/features/shared/components/Modal/Modal";
import ProjectTableFilters from "@/features/project/components/ProjectTableFilters";
import ProjectTable from "@/features/project/components/ProjectTable";
import ProjectPagination from "@/features/project/components/ProjectPagination";
import ProjectForm from "@/features/project/components/ProjectForm";
import useProjects from "@/features/project/hooks/useProjects";
import { IoMdAdd } from "react-icons/io";
import useClients from "@/features/client/hooks/useClients";
import { toast } from "react-toastify";
const ProjectsPage = () => {
    const [filters, setFilters] = useState({ label: "", client_denomination: "", ice: "", ville: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [formError, setFormError] = useState(null);
    // The hook automatically refetches whenever currentPage or filters change.
    const { projects, meta, loading, error, refetchProjects, handleAddProject, handleUpdateProject, handleDeleteProject } = useProjects(currentPage, filters, false, rowsPerPage);
    const { handleAddClient } = useClients();
    const handleFilterChange = (filterName, value) => {
        setFilters(prev => ({ ...prev, [filterName]: value }));
        setCurrentPage(1); // Reset to first page on filter change.
    };
    const handleResetFilters = () => {
        setFilters({ label: "", client_denomination: "", ice: "", ville: "" });
    };
    const handleAddProjectClick = () => {
        setSelectedProject(null);
        setIsModalVisible(true);
    };
    const handleEdit = (project) => {
        setSelectedProject(project);
        setIsModalVisible(true);
    };
    const handleDelete = async (idProject) => {
        try {
            await handleDeleteProject(idProject);
            toast.success("Projet supprimé");
        }
        catch (error) {
            toast.error(`Erreur : ${error.message}`);
        }
    };
    const handleSubmit = async (projectData, isNewClient) => {
        try {
            setFormError(null);
            let clientAdded;
            if (isNewClient && projectData.client) {
                clientAdded = await handleAddClient(projectData.client);
                if (clientAdded) {
                    projectData = { ...projectData, client_id: clientAdded.id };
                }
            }
            if (selectedProject && projectData.id) {
                await handleUpdateProject(projectData.id, projectData);
                toast.success("Modifications enregistrées");
            }
            else {
                await handleAddProject(projectData);
                toast.success("Projet enregistré");
            }
            setIsModalVisible(false);
            // React Query will automatically refresh the data.
        }
        catch (error) {
            setFormError(error.message);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    if (loading) {
        return _jsx("div", { className: "p-4", children: "Chargement..." });
    }
    if (error) {
        return (_jsxs("div", { className: "p-4 text-red-500", children: ["Erreur lors du chargement des projets : ", error, _jsx("button", { onClick: () => refetchProjects(), className: "ml-4 bg-blue-500 text-white px-2 py-1 rounded", children: "R\u00E9essayer" })] }));
    }
    return (_jsxs("div", { className: "p-4 bg-gray-50 min-h-screen", children: [_jsxs("div", { className: "flex col-auto gap-4 mb-2", children: [_jsx("h4", { className: "text-xl font-bold", children: "Projets" }), _jsx("button", { onClick: handleAddProjectClick, title: "Cr\u00E9er un projet", className: "rounded", children: _jsx(IoMdAdd, { className: "bg-blue-500 text-white hover:bg-blue-600" }) })] }), _jsx(ProjectTableFilters, { filters: filters, onFilterChange: handleFilterChange, onResetFilters: handleResetFilters }), _jsx(ProjectTable, { projects: projects, onEdit: handleEdit, onDelete: handleDelete }), meta && (_jsx(ProjectPagination, { currentPage: meta.page ?? 1, totalPages: meta.totalPages ?? 1, limit: rowsPerPage, onPageChange: (page) => setCurrentPage(page), onLimitChange: (value) => {
                    setRowsPerPage(value);
                    setCurrentPage(1);
                } })), isModalVisible && (_jsx(Modal, { onClose: () => setIsModalVisible(false), children: _jsx(ProjectForm, { initialData: selectedProject ?? undefined, onSubmit: handleSubmit, onCancel: () => setIsModalVisible(false) }) })), formError && (_jsxs("div", { className: "mt-4 p-3 bg-red-100 text-red-700 rounded", children: ["Erreur : ", formError] }))] }));
};
export default ProjectsPage;
